import { render, staticRenderFns } from "./edit-transfer-protocol-modal.vue?vue&type=template&id=eecb0a28&scoped=true"
import script from "./edit-transfer-protocol-modal.vue?vue&type=script&lang=js"
export * from "./edit-transfer-protocol-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eecb0a28",
  null
  
)

export default component.exports